const noop = () => {};

export const scrollToPageTop = () => {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

export const scheduleScrollToPageTop = () => {
  if (typeof window === "undefined") return noop;

  scrollToPageTop();

  const frameId = typeof window.requestAnimationFrame === "function"
    ? window.requestAnimationFrame(scrollToPageTop)
    : null;
  const timeoutId = window.setTimeout(scrollToPageTop, 0);

  return () => {
    if (frameId !== null && typeof window.cancelAnimationFrame === "function") {
      window.cancelAnimationFrame(frameId);
    }
    window.clearTimeout(timeoutId);
  };
};
